import React from 'react';
import { SpaceBetween } from '@cloudscape-design/components';
import PageHeader from '../components/common/Header';
import PipelinesTable from '../components/pipelines/PipelinesTable';
import { HeaderProps, PipelinesTableProps, TimeframePeriod } from '../types';

interface PipelinesPageProps extends HeaderProps, Omit<PipelinesTableProps, 'items'> {
  items: any[];
}

const PipelinesPage: React.FC<PipelinesPageProps> = ({
  environment,
  onEnvironmentChange,
  timePeriod,
  onTimePeriodChange,
  darkMode,
  onDarkModeChange,
  items,
  selectedItems,
  onSelectionChange,
  filteringQuery,
  onFilteringChange,
  loading,
  onRefresh,
}) => {
  // Map the existing timePeriod to our TimeframePeriod type
  const mapTimePeriodToTimeframe = (period: any): TimeframePeriod => {
    const value = period?.value?.toLowerCase() || 'weekly';
    switch (value) {
      case 'daily':
      case '1d':
      case 'day':
        return 'daily';
      case 'weekly':
      case '1w':
      case 'week':
        return 'weekly';
      case 'monthly':
      case '1m':
      case 'month':
        return 'monthly';
      case 'yearly':
      case '1y':
      case 'year':
        return 'yearly';
      default:
        return 'weekly';
    }
  };

  const timeframe = mapTimePeriodToTimeframe(timePeriod);

  return (
    <SpaceBetween direction="vertical" size="l">
      <PageHeader
        title="Pipelines monitor"
        environment={environment}
        onEnvironmentChange={onEnvironmentChange}
        timePeriod={timePeriod}
        onTimePeriodChange={onTimePeriodChange}
        darkMode={darkMode}
        onDarkModeChange={onDarkModeChange}
      />
      <PipelinesTable
        items={items}
        selectedItems={selectedItems}
        onSelectionChange={onSelectionChange}
        filteringQuery={filteringQuery}
        onFilteringChange={onFilteringChange}
        loading={loading}
        timeframe={timeframe}
        onRefresh={onRefresh}
      />
    </SpaceBetween>
  );
};

export default PipelinesPage;
